/* tslint:disable:max-line-length indent no-trailing-whitespace component-selector */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PbiReport }  from './pbi-report.model'

@Injectable({providedIn: 'root'})
export class PbiEmbedService  {

	private pbiRptBaseUrl: string = "https://app.powerbi.com/reportEmbed";
	private pbiRptParmAutoAuth: string = "&autoAuth=true";
	private pbiRptParmCtid: string = "&ctid=fa4c197a-da3e-4c1a-b014-83bb94694ba9";
	private pbiRptParmConfig: string ="&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtYy1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9"
	private pbiRptParmRptid: string = "?reportId=";

	private url: string;

	constructor(
		private httpClient: HttpClient) {
		this.url = 'api/PowerBiReport/';
	}

	public getAllPbiReports(): Observable<PbiReport[]> {
		return this.httpClient.get<PbiReport[]>(this.url + 'GetAllPbiReportsAsync/');
	}
	
	public getPbiReportUrl(rptGuid: string): string {
		/*** assemble PBI report URL: url parameter names are case sensative!! e.g. &autoAuth=
		 https://app.powerbi.com/reportEmbed?reportId=7d07c7a6-e900-45df-bb55-cddac1762fa7&autoAuth=true&ctid=fa4c197a-da3e-4c1a-b014-83bb94694ba9&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtYy1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9
		***/
		return this.pbiRptBaseUrl + (this.pbiRptParmRptid + rptGuid) + this.pbiRptParmAutoAuth + this.pbiRptParmCtid + this.pbiRptParmConfig;
	}
}
